<template>
  <!-- Vista de botones -->
  <v-dialog
    v-model="dialogframe"
    persistent
    transition="dialog-bottom-transition"
    width="1000"
  >
    <v-card>
      <v-toolbar dark color="red-darken-4">
        <v-toolbar-title
          ><v-icon left>mdi-microsoft-excel</v-icon> Parametros Reportes -
          {{ namereporte }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn
            class="d-none d-md-block"
            dark
            text
            @click="dialogframe = false"
            >Cerrar</v-btn
          >
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-form autocomplete="off">
          <v-container
            v-if="parametrizacion != [] && parametrizacion != null"
            fluid
          >
            <v-row>
              <v-col
                v-for="(datos, i) in parametrizacion"
                :key="i"
                cols="12"
                sm="12"
                :lg="'6'"
              >
                <!-- Fechas-->
                <v-text-field
                  v-if="datos.Naturaleza == 'F'"
                  type="date"
                  v-model="datos.ValorFecha"
                  hint="Digite una fecha válida"
                  :error="datos.CampoFalta"
                  :error-messages="
                    datos.CampoFalta ? ['Campo Obligatorio'] : ''
                  "
                  :rules="[
                    rules.obligatorio(datos.Obligatorio, datos.ValorFecha),
                  ]"
                  :label="datos.Label"
                  clearable
                ></v-text-field>
                <!-- Texto -->
                <v-text-field
                  v-else-if="datos.Naturaleza == 'A'"
                  v-model="datos.ValorAlfa"
                  hint="Digite una texto"
                  :error="datos.CampoFalta"
                  :error-messages="
                    datos.CampoFalta ? ['Campo Obligatorio'] : ''
                  "
                  :rules="[
                    rules.obligatorio(datos.Obligatorio, datos.ValorAlfa),
                  ]"
                  :label="datos.Label"
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
        <div align="right">
          <v-btn
            dark
            size="large"
            prepend-icon="mdi-microsoft-excel"
            color="#05AD58"
            text
            @click="ValidateCampos"
            >Descargar</v-btn
          >
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
  <v-data-table
    :headers="headers"
    :items="desserts"
    :search="search"
    item-value="name"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-spacer></v-spacer>
        <!-- Buscador -->
        <v-text-field
          v-model="search"
          append-inner-icon="mdi-magnify"
          label="Buscar..."
          single-line
          variant="underlined"
          hide-details
        ></v-text-field>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <!-- Consulta de documento  -->
      <v-tooltip
        v-if="item.raw.TipoReporte != 'L'"
        location="bottom"
        color="white"
      >
        <template v-slot:activator="{ props }">
          <v-btn
            v-bind="props"
            @click="IconosReporte(item.raw)"
            color="green"
            :icon="
              item.raw.PaginaParametros == 'S'
                ? 'mdi-cursor-default-click'
                : 'mdi-monitor-arrow-down'
            "
            size="x-small"
          ></v-btn>
        </template>
        <span>{{
          item.raw.PaginaParametros == "S"
            ? "Digitación de campos"
            : "Descarga Reporte"
        }}</span>
      </v-tooltip>

      <!-- Consulta de reportes link  -->
      <v-tooltip
        v-else-if="item.raw.TipoReporte == 'L'"
        location="bottom"
        color="white"
      >
        <template v-slot:activator="{ props }">
          <v-btn
            v-bind="props"
            :href="item.raw.NombrePrograma"
            target="_blank"
            color="blue-darken-4"
            icon="
             mdi-eye-arrow-right-outline
            "
            size="x-small"
          ></v-btn>
        </template>
        <span> Visualizar reporte externo</span>
      </v-tooltip>
    </template>
  </v-data-table>
  <div class="d-flex align-center flex-column">
    <!-- Linea de progreso -->
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import store from "@/store";
var M_interface = [];
export default {
  data() {
    return {
      progreso: false,
      dialogframe: false,
      search: null,
      headers: [
        {
          title: "Reporte ID:",
          align: "left",
          key: "Reporte_ID",
        },
        {
          title: "Reporte",
          align: "left",
          key: "NombreReporte",
        },
        {
          title: "Acciones",
          align: "center",
          sortable: false,
          key: "actions",
        },
      ],
      infourl: {
        url: "",
        archivo: "",
        rutarchivo: "",
      },
      parametrizacion: [],
      desserts: [],
      param1: "",
      namereporte: "",
      llaves: {
        TypeDocument_ID: "",
        Document_ID: "",
        Primer_Apellido: "",
        Segundo_Apellido: "",
        Primer_Nombre: "",
        Segundo_Nombre: "",
        Solicitud: "",
        Contrato: "",
        Ref_1: "",
        Ref_2: "",
        Ref_3: "",
        IDServicio: "",
        IDPoliza: "",
        Secuencia_ID: "",
        UsuarioLogin: "",
        EntradaReportes: {
          Reporte: 0,
          Origen: "S", // Sistema
          Parametros: [],
        },
      },
      rules: {
        obligatorio(isRequired, v) {
          if (isRequired == "S") {
            return !!v || "Este campo es obligatorio.";
          } else {
            return true;
          }
        },
      },
    };
  },
  ///////////////////////////////////////////////// Métodos de Watch ///////////////////////////////////////////
  watch: {
    // Colocar ya que el sistema al ver que la URL ya esta cargada no la vuelve a cargar
    $route: function () {
      this.desserts = [];
      var userperfil = this.$store.getters.userperfil;
      this.llaves.UsuarioLogin = userperfil.userInfo.Usuario_ID;
      this.parametrospaginas();
    },
  },

  methods: {
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Consulta Reportes
    async getReporte() {
      this.progreso = true;
      this.axios
        .get("/reportes/consultarreportes?grupo=" + this.param1)
        .then((result) => {
          this.desserts = result.data;
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: " [404] No existen datos para esta consulta.",
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " [500] El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },
    // Validación de campos
    async ValidateCampos() {
      var validate = false;
      for (var i = 0; i < this.parametrizacion.length; i++) {
        this.parametrizacion[i].CampoFalta = false;
        if (this.parametrizacion[i].Obligatorio == "S") {
          switch (this.parametrizacion[i].Naturaleza) {
            case "N":
              // Validamos que el campos sea mayor a 0
              if (
                this.parametrizacion[i].ValorNumerico == 0 ||
                this.parametrizacion[i].ValorNumerico == null
              ) {
                validate = true;
                this.parametrizacion[i].CampoFalta = true;
              }
              break;
            case "F":
              if (
                this.parametrizacion[i].ValorFecha == "1810-01-01" ||
                this.parametrizacion[i].ValorFecha == "" ||
                this.parametrizacion[i].ValorFecha == null
              ) {
                validate = true;
                this.parametrizacion[i].CampoFalta = true;
              }
              break;
            case "A":
              if (
                this.parametrizacion[i].ValorAlfa == "0" ||
                this.parametrizacion[i].ValorAlfa == "" ||
                this.parametrizacion[i].ValorAlfa == null
              ) {
                validate = true;
                this.parametrizacion[i].CampoFalta = true;
              }
              break;
          }
        }
      }
      // Consultas a Ejecutar
      if (!validate) {
        this.PostDescargaExcel();
      } else {
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " Hay campos que se encuentran incompletos.",
        });
      }
    },
    // Consulta Reportes
    async PostDescargaExcel() {
      this.llaves.EntradaReportes.Parametros = this.parametrizacion;
      var data = this.llaves;
      this.progreso = true;
      this.axios
        .post("/reportes/generarreportes/", data, {
          timeout: 60000, // 60 segundos
        })
        .then((result) => {
          this.infourl.url = result.data;
          this.download();
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: " [404] No existen datos para esta consulta.",
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " [500] El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },

    // Método para descargar el Documento consultado
    download() {
      // Definir el tipo MIME y la extensión del archivo según el formato
      let mimeType;
      let extension;

      mimeType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      extension = ".xlsx";
      this.dialogframe = false;

      // Crear un enlace de descarga para descargar el archivo
      const link = document.createElement("a");
      link.href = `data:${mimeType};base64,${this.infourl.url}`;
      link.download = `archivo${extension}`; // El nombre del archivo con la extensión
      link.click(); // Dispara la descarga

      this.$swal({
        icon: "success",
        title: "¡Descargado!",
        html: " El archivo fue descargado con éxito revise el explorador de archivos del PC.",
      });
    },
    ///////////////////////////////////////////////// Métodos de acciones ///////////////////////////////////////////
    IconosReporte(inforeporte) {
      this.llaves.EntradaReportes.Reporte = 0;
      this.llaves.EntradaReportes.Parametros = [];
      this.namereporte = "";
      debugger;
      if (inforeporte.PaginaParametros == "S") {
        this.parametrizacion = [];
        var Seleccion = [];
        for (var i = 0; i < inforeporte.ReportesSeleccion.length; i++) {
          inforeporte.ReportesSeleccion[i].ValorNumerico = 0;
          inforeporte.ReportesSeleccion[i].ValorAlfa = "";
          inforeporte.ReportesSeleccion[i].ValorFecha = "";
          Seleccion.push(inforeporte.ReportesSeleccion[i]);
        }
        this.parametrizacion = Seleccion;
        this.dialogframe = true;
        this.namereporte = inforeporte.NombreReporte;
        this.llaves.EntradaReportes.Reporte = inforeporte.Reporte_ID;
      } else {
        this.namereporte = inforeporte.NombreReporte;
        this.llaves.EntradaReportes.Reporte = inforeporte.Reporte_ID;
        this.ValidateCampos();
      }
    },
    // Busca los parametros de la pagina
    parametrospaginas() {
      var page = this.$store.getters.userperfil.paginainfo;
      if (page.param1) {
        this.param1 = page.param1;
      }
      this.getReporte();
    },
  },
  mounted() {
    this.parametrospaginas();
    var userperfil = this.$store.getters.userperfil;
    this.llaves.UsuarioLogin = userperfil.userInfo.Usuario_ID;
  },
};
</script>
